// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/user-group.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/user-group'

import { Icon, type IconComponentProps } from '../icon'

export const UserGroupIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
